import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getInboundShipmentMetrics = unaryRpc({
  name: "getInboundShipmentMetrics" as const,
  input: z.object({
    returnsCenterId: z.string().optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
  }),
  output: z.object({
    pending: z.number(),
    scheduled: z.number(),
    inTransit: z.number(),
    delivered: z.number(),
  }),
});

export type InboundShipmentMetricsOutput = z.infer<
  (typeof getInboundShipmentMetrics)["output"]
>;
